var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    viewBox: "0 0 16 17",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.1495 6.15487-4.5242-.41061-1.7667-4.35053c-.31781-.791899-1.40212-.791899-1.71994 0l-1.76668 4.3603-4.514852.40084c-.8225819.06844-1.159093 1.14385-.532809 1.71088l3.430541 3.10895-1.02823 4.6145c-.18695.8407.68237 1.5055 1.39278 1.0558l3.87922-2.4441 3.87927 2.4539c.7104.4497 1.5797-.2151 1.3927-1.0559l-1.0282-4.6242 3.4305-3.10895c.6263-.56703.2992-1.64244-.5234-1.71088zm-7.15087 6.21783v-9.09211l1.59843 3.94969 4.09424.37151-3.1034 2.81561.9347 4.1843z",
    fill: "#ffb547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.f8079754e3a6533ef1455ab3ed780dc0.svg";
export { ForwardRef as ReactComponent };